import { message } from 'antd';
import Emitter from '../../services/emitter';
import Mscratch from '../../services/mscratch';
import History from '../../util/history';
import mElectronApi from '../../util/electron';
import { getFileSuffix } from '../../util';

import ProjectAction from '../project/action';
import projectModel from '../../model/project.model';

import CONSTANT from '../../constant';
import ProjectApi from '../../services/api/project';
import Storage from '../../services/api/store';
import store from '../../reducers';
import { isWeb } from '../../util/env';

/**
 * 新建
 *
 */
export const onNew = () => {
    if(History.location.pathname != '/') {
        projectModel.setSaved();
    }
    Emitter.emit('NewProject');
};

/**
 * 打开项目
 *
 */
export const onOpen = async (file) => {
    Emitter.emit('OpenProject', file);
};

/**
 * 保存项目
 *
 */
export const onSave = (isSaveas) => {
    Emitter.emit('SaveProject', isSaveas);
};

/**
 * 导出项目
 *
 */
export const onExport = () => {
    Emitter.emit('ExportProject', {}, 'web');
};

/**
 * 导入项目
 *
 */
export const onImport = () => {
    Emitter.emit('ImportProject');
};

export default () => {
    const onNewProject = () => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'fs';
        console.log('调用project->NewProject：', tab);
        ProjectAction.Strategy(store, tab).NewProject();
    };

    const onOpenProject = async (file, tab = 'fs', callbackOrParams) => {
        tab = (store.getState().env.env === 'web') ? 'web' : tab;
        console.log('调用project->OpenProject：', tab);
        await ProjectAction.Strategy(store, tab).OpenProject(file, callbackOrParams);
    };

    const onSaveProject = async (isSaveas, tab = 'fs', projectInfo = {}, successCallback) => {
        tab = (store.getState().env.env === 'web') ? 'web' : tab;
        console.log('调用project->SaveProject：', tab);
        try {
            await ProjectAction.Strategy(store, tab).SaveProject(isSaveas, projectInfo, successCallback);
        } catch (err) {
            const { intlr } = store.getState();
            const { messages } = intlr;
            const failMsg = messages['EXPORT.FAIL.MSG'];
            if (err.matchStr) {
                message.error(err.matchStr + messages['RENAME.ERR.KEY.MSG']);
            } else if (err.msg) {
                message.error(messages[err.msg]);
            } else {
                message.error(failMsg);
            }
        }
    };

    const onShortcutkey = (action) => {
        const { project, intlr } = store.getState();
        const { name } = project;
        let isSaveas = false;
        if (action === 'save' && History.location.pathname === '/') {
            isSaveas = false;
            if (project.projectType === CONSTANT.PROJECT_TYPE.LOCAL) {
                onSaveProject(isSaveas, 'fs');
            } else {
                onSaveProject(isSaveas, 'yun');
            }
        }
        if (action === 'saveas' && History.location.pathname === '/') {
            isSaveas = true;
            if (project.projectType !== CONSTANT.PROJECT_TYPE.LOCAL) {
                const projectName = name ? name : ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects);
                History.replace(`/project/saveas/my/${projectName}`);
            } else {
                onSaveProject(isSaveas, 'fs');
            }
        }
    };

    const onUpdateProjectFromUrl = () => {
        ProjectAction.Strategy(store, 'web').updateRemoteProjectFromUrl();
    };

    const onCopyProject = (data, cb) => {
        ProjectAction.Strategy(store, 'yun').copyProject(data, cb);
    };

    const onExportProject = async (data, tab, cb) => {
        ProjectAction.Strategy(store, tab).exportProject(data, cb);
    };

    const onImportProject = async (cb) => {
        ProjectAction.Strategy(store, 'web').importProject(cb);
    };

    const onDeleteProject = (id, cb) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        ProjectAction.Strategy(store, tab).deleteProject(id, cb);
    };

    const onConfirmSave = async (isYes, type, projectInfo = {}) => {
        Mscratch.stop();
        let tab = (store.getState().env.env === 'web') ? 'web' : 'fs';
        if (isYes) {
            store.dispatch(ProjectAction.confirmType(type));
            const changeToTab = () => {
                const { project } = store.getState();
                const { projectType } = project;
                switch (projectType) {
                    case CONSTANT.PROJECT_TYPE.LOCAL:
                        return 'fs';
                    case CONSTANT.PROJECT_TYPE.LIST:
                    case CONSTANT.PROJECT_TYPE.EXAMPLE:
                    default:
                        return 'yun';
                }
            };
            await onSaveProject(false, changeToTab(), projectInfo);
            ProjectAction.Strategy(store, tab).savedFinishExec(type);
        } else {
            projectModel.setSaved();
            ProjectAction.Strategy(store, tab).savedFinishExec(type);
        }
    };

    const onDragAddProject = file => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        if (file instanceof File) {
            const { intlr } = store.getState();
            const suffix = getFileSuffix(file.name);
            const lcSuffix = suffix.toLowerCase();
            if (CONSTANT.PROJECT_SUFFIX.indexOf(lcSuffix) !== -1) {
                ProjectAction.Strategy(store, tab).dragAddProject(file);
                // 不支持解析拖拽的文件
            } else {
                message.error(`『 ${file.name} 』 ${intlr.messages['IMPORT.FORMAT.ERROR.MSG']} `);
            }
        }
    };

    const onDragOpenFile = (file) => {
        if (file instanceof File) {
            const { intlr } = store.getState();
            const suffix = getFileSuffix(file.name);
            const lcSuffix = suffix.toLowerCase();
            if (CONSTANT.PROJECT_SUFFIX.indexOf(lcSuffix) !== -1) {
                store.dispatch(ProjectAction.file(file));
                store.dispatch(ProjectAction.saved({projectType: CONSTANT.PROJECT_TYPE.LOCAL}));
                const tab = isWeb() ? 'web' : 'fs';
                onOpenProject(file, tab, {
                    projectType: CONSTANT.PROJECT_TYPE.LOCAL
                });
            }
            // 如果是 zip 则走扩展解析
            else if (lcSuffix === 'zip') {
                const extractPath = `exts/${file.name.replace(`.${suffix}`, '')}`;
                mElectronApi.uncompress({
                    file,
                    extractPath,
                    onProgress: () => {
                    },
                    onFinish: async () => {
                        const info = await fetch(`${extractPath}/manifest.json`).then(res => res.json());
                        Mscratch.loadedExt(info);
                    },
                    onError: () => {
                    }
                });
            }
            // 不支持解析拖拽的文件
            else {
                message.error(`『 ${file.name} 』 ${intlr.messages['IMPORT.FORMAT.ERROR.MSG']} `);
            }
        }
    };

    const onLoadExample = (data, name) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'fs';
        ProjectAction.Strategy(store, tab).loadExample(data, name);
    };

    const onRenameProject = (data, tab = 'fs', callback) => {
        ProjectAction.Strategy(store, tab).RenameProject(data, callback);
    };

    const onSyncList = (successCb, failCb) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        if(tab == 'yun') {
            projectModel.createNewProject();
        }
        ProjectAction.Strategy(store, tab).syncList(successCb, failCb);
    };

    const onReDownloadProject = (callback) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        ProjectAction.Strategy(store, tab).ReDownloadProject(callback);
    };

    const onClearProjects = () => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        ProjectAction.Strategy(store, tab).clearProjects();
    };

    const onRenameRuntime = (name) => {
        store.dispatch(ProjectAction.saved({ name }));
    };

    const onShareProject = (data, cb) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        ProjectAction.Strategy(store, tab).shareProject(data, cb);
    };

    const onCancelShareProject = (id, cb) => {
        let tab = (store.getState().env.env === 'web') ? 'web' : 'yun';
        ProjectAction.Strategy(store, tab).cancelShareProject(id, cb);
    };

    const onUpdateUploadStatus = (payload) => {
        store.dispatch(ProjectAction.Upload(payload));
    };

    const onMscratchDidMount = () => {
        Storage.set(CONSTANT.INSTALLED_EXT, []);
        setTimeout(() => {
            projectModel.setSaved();
        }, 1200);
    };

    // 确认是否保存
    Emitter.on('ConfirmToSave', onConfirmSave);
    // 加载实例程序
    Emitter.on('LoadExample', onLoadExample);

    Emitter.on('UpdateProjectFromUrl', onUpdateProjectFromUrl);

    // 点击创建新作品
    Emitter.on('NewProject', onNewProject);
    // 拖拽创建新作品
    Emitter.on('DragAddProject', onDragAddProject);
    // 拖拽打开作品
    Emitter.on('DragOpenFile', onDragOpenFile);
    // 打开作品
    Emitter.on('OpenProject', onOpenProject);

    // 保存作品
    Emitter.on('SaveProject', onSaveProject);
    // 作品重命名
    Emitter.on('RenameProject', onRenameProject);
    // 复制作品
    Emitter.on('CopyProject', onCopyProject);
    // 导入作品
    Emitter.on('ImportProject', onImportProject);
    // 导出作品到本地
    Emitter.on('ExportProject', onExportProject);
    // 删除作品
    Emitter.on('DeleteProject', onDeleteProject);
    // 分享作品
    Emitter.on('ShareProject', onShareProject);
    // 取消分享作品
    Emitter.on('CancelShareProject', onCancelShareProject);

    // 重命名 只改store
    Emitter.on('RenameRuntime', onRenameRuntime);
    // 上传后更新store信息
    Emitter.on('UpdateUploadStatus', onUpdateUploadStatus);

    // 同步作品列表
    Emitter.on('SyncList', onSyncList);
    // 下载作品重试
    Emitter.on('ReDownloadProject', onReDownloadProject);
    // 快捷键操作
    Emitter.on('Shortcutkey', onShortcutkey);
    // 清空作品列表
    Emitter.on('ClearProjects', onClearProjects);
    Emitter.on('MscratchDidMount', onMscratchDidMount);

};